import { resizeObservers as r } from "./ghl-ui.es1605.js";
var n = function() {
  return r.some(function(e) {
    return e.activeTargets.length > 0;
  });
};
export {
  n as hasActiveObservations
};
